// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__FemIz","form_content":"Create_form_content__aupmf"};